import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BYPASS_ERROR_NOTIFICATION } from '@assess/browser/http-interceptors';
import { IAssignTask, ITask, IWorkflowInstance } from '@assess/shared/workflow';

import { BrowserWorkflowApiConfiguration } from '../browser-workflow-api-configuration';

@Injectable({ providedIn: 'root' })
export class WorkflowHttpService {
  readonly rootUrl: string;

  constructor(
    readonly config: BrowserWorkflowApiConfiguration,
    private readonly http: HttpClient
  ) {
    this.rootUrl = config.rootUrl;
  }

  getWorkflowInstance(workflowInstanceId: string): Observable<IWorkflowInstance> {
    const url = this.url(`tasks/${workflowInstanceId}`);

    return this.http.get<IWorkflowInstance>(url);
  }

  checkoutTask(workflowInstanceId: string, taskId: string): Observable<IWorkflowInstance> {
    const url = this.url(`tasks/${workflowInstanceId}/checkout/${taskId}`);

    // This call will set a cookie called JWT for allowing to save to the Form in Data Mart
    return this.http.get<IWorkflowInstance>(url, {
      withCredentials: true,
    });
  }

  assignTask(workflowInstanceId: string, taskId: string, assignTaskInfo: IAssignTask, bypassError = false) {
    const url = this.url(`tasks/${workflowInstanceId}/assign/${taskId}`);

    const context = new HttpContext();
    if (bypassError) {
      context.set(BYPASS_ERROR_NOTIFICATION, true);
    }

    return this.http.post<ITask>(url, assignTaskInfo, { context });
  }

  private url(path: string): string {
    return `${this.rootUrl}/${path}`;
  }
}
